<template>
  <a-layout style="padding-top: 65px;">
    <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '720px' }">
      <p>
        <a-form layout="inline" :model="param">
          <a-form-item>
            <a-input v-model:value="param.loginName" placeholder="登陆名" :allowClear="true">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="resetQuery" style="background: #E6A23C">
              重置
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleQuery({ page: 1, size: pagination.pageSize })">
              查询
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="add()">
              新增
            </a-button>
          </a-form-item>
        </a-form>
      </p>
      <!-- :row-key="record => record.id" -->
      <!-- warning.js:6 Warning: [ant-design-vue: Table] `column.slots` is deprecated. Please use `v-slot:headerCell` `v-slot:bodyCell` instead. -->
      <a-table :columns="columns" :data-source="users" :pagination="pagination" :loading="loading"
        @change="handleTableChange">
        <template v-slot:action="{ record }"> <!-- { text, record } -->
          <a-space size="small">
            <a-button type="primary" @click="resetPassword(record)">
              重置密码
            </a-button>
            <a-button type="primary" @click="edit(record)">
              编辑
            </a-button>
            <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
              <a-button type="primary" danger>
                删除
              </a-button>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-layout-content>
    <TheFooter></TheFooter>
  </a-layout>

  <!-- Warning: [ant-design-vue: Modal] `visible` will be removed in next major version, please use `open` instead. -->
  <a-modal title="用户表单" v-model:open="modalVisible" :confirm-loading="modalLoading" @ok="handleModalOk">
    <a-form :model="user" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="登陆名">
        <a-input v-model:value="user.loginName" :disabled="!!user.id" :allowClear="true" />
      </a-form-item>
      <a-form-item label="昵称">
        <a-input v-model:value="user.name" :allowClear="true" />
      </a-form-item>
      <a-form-item label="密码" v-show="!user.id">
        <a-input v-model:value="user.password" type="password" :allowClear="true" />
      </a-form-item>
    </a-form>
  </a-modal>

  <!-- Warning: [ant-design-vue: Modal] `visible` will be removed in next major version, please use `open` instead. -->
  <a-modal title="重置密码" v-model:open="resetModalVisible" :confirm-loading="resetModalLoading" @ok="handleResetModalOk">
    <a-form :model="user" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="新密码">
        <a-input v-model:value="user.password" type="password" :allowClear="true" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import TheFooter from "@/components/the-footer.vue";

declare let hexMd5: any;
declare let KEY: any;

export default defineComponent({
  name: 'AdminUser',
  components: {
    TheFooter
  },
  setup() {
    const param = ref();
    param.value = {};
    const users = ref();
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0
    });
    const loading = ref(false);

    const columns = [
      {
        title: '登陆名',
        dataIndex: 'loginName'
      },
      {
        title: '名称',
        dataIndex: 'name'
      },
      {
        title: '密码',
        dataIndex: 'password'
      },
      {
        title: 'Action',
        key: 'action',
        slots: { customRender: 'action' }
      }
    ];

    /**
     * 数据查询
     **/
    const handleQuery = (params: any) => {
      loading.value = true;
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑，则列表显示的还是编辑前的数据
      users.value = [];
      axios.post("/user/list", {
        // @GetMapping params: {...} 
        // @PostMapping 后台需要加 @RequestBody
        page: params.page,
        size: params.size,
        loginName: param.value.loginName
      }).then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          users.value = result.data.list;

          // 重置分页按钮
          pagination.value.current = params.page;
          pagination.value.total = result.data.total;
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 重置
     */
    const resetQuery = () => {
      console.log('resetQuery ... ')
      // 清空表单
      param.value.loginName = undefined
      // 重新查询
      handleQuery({
        page: 1,
        size: 10,
      });
    };

    /**
     * 表格点击页码时触发
     */
    const handleTableChange = (pagination: any) => {
      console.log("看看自带的分页参数都有啥：" + pagination);
      handleQuery({
        page: pagination.current,
        size: pagination.pageSize
      });
    };

    // ------------------------ 表单提交 ------------------------
    const user = ref();
    const modalVisible = ref(false);
    const modalLoading = ref(false);
    const handleModalOk = () => {
      console.log('user', user.value)
      // 校验数据
      if (user.value.loginName == undefined || user.value.loginName.trim() == ''
        || user.value.name == undefined || user.value.name.trim() == ''
      ) {
        message.warning('请补全数据')
        return
      }
      // 新增时再判断补全密码
      if (user.value.id == undefined && (user.value.password == undefined || user.value.password.trim() == '')) {
        message.warning('请补全数据')
        return
      }

      modalLoading.value = true;
      // 密码MD5加密
      user.value.password = hexMd5(user.value.password + KEY);
      // 提交数据
      axios.post("/user/save", user.value).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalVisible.value = false;
          message.success('提交成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 编辑
     */
    const edit = (record: any) => {
      console.log('edit ... ', record)
      modalVisible.value = true;
      user.value = Tool.copy(record);
    };

    /**
     * 新增
     */
    const add = () => {
      modalVisible.value = true;
      user.value = {};
    };

    // ------------------------ 删除 -------------------------
    const handleDelete = (id: number) => {
      console.log('handleDelete => ', id)

      axios.delete("/user/delete/" + id).then((response) => {
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('删除成功')
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });
    };

    // ------------------------ 重置密码 -------------------------
    const resetModalVisible = ref(false);
    const resetModalLoading = ref(false);
    const handleResetModalOk = () => {
      resetModalLoading.value = true;

      user.value.password = hexMd5(user.value.password + KEY);

      axios.post("/user/reset-password", user.value).then((response) => {
        resetModalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          resetModalVisible.value = false;
          message.success('修改成功');
          // 重新加载列表
          handleQuery({
            page: pagination.value.current,
            size: pagination.value.pageSize,
          });
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 重置密码
     */
    const resetPassword = (record: any) => {
      console.log('resetPassword ... ', record)
      resetModalVisible.value = true;
      user.value = Tool.copy(record);
      user.value.password = null;
    };

    onMounted(() => {
      handleQuery({
        page: 1,
        size: pagination.value.pageSize,
      });
    });

    return {
      param,
      users,
      pagination,
      columns,
      loading,
      handleTableChange,
      handleQuery,
      resetQuery,

      edit,
      add,

      user,
      modalVisible,
      modalLoading,
      handleModalOk,

      handleDelete,

      resetModalVisible,
      resetModalLoading,
      handleResetModalOk,
      resetPassword
    }
  }
});
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
}
</style>
